import React from 'react';
import translate from '@/lib/intl/translate';
import ContentBody from './ContentBody';

type InteractionContentProps = {
  interaction: {
    developers?: unknown[];
    interactionId?: string;
    notes?: unknown[];
  };
};

function InteractionContent({ interaction }: InteractionContentProps) {
  const { developers, notes } = interaction;
  // @ts-expect-error TS(2571) TODO(ts-migrate): Object is of type 'unknown'.
  const note = notes?.length ? notes[0].text : '';
  return (
    <ContentBody
      assignees={developers}
      assigneeTitle={translate('FEED_SLIDER_GENERIC_ASSIGNED_TITLE')}
      contentItems={[
        {
          key: 'note',
          className: 'col-span-full',
          value: note,
        },
      ]}
      entityId={interaction.interactionId}
      title={translate('FEED_SLIDER_GENERIC_NOTES_TITLE')}
    />
  );
}

export default InteractionContent;
